import { NavigateFunction, NavigateOptions, To } from 'react-router-dom';

const History: {
    navigate: NavigateFunction | null;
    push: (to: To, options?: NavigateOptions | undefined) => void;
} = {
    navigate: null,
    push: (page, ...rest) => History.navigate && History.navigate(page, ...rest),
};

export default History;
